import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { fetchFeaturedListings } from '../../ducks/featuredListings.duck';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { getFeaturedListingsProps } from '../../util/data';
import { departmentFromPageId } from '../../util/racingThemeDepartment';
import { shouldNoIndexCmsPage } from '../../util/cmsPageIndexing';

import { withRacingThemeSectionComponents } from '../PageBuilder/racingThemeCms';
import { useResolvedRacingThemePageData } from '../PageBuilder/racingThemeCms/useResolvedRacingThemePageData';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import css from './CMSPage.module.css';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const { params, pageAssetsData, inProgress, error } = props;
  const pageId = params?.pageId || props.pageId;
  const rawPageData = pageAssetsData?.[pageId]?.data;
  const resolvedPageData = useResolvedRacingThemePageData(pageId, rawPageData);
  const department = departmentFromPageId(pageId);

  if (!inProgress && error?.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  return (
    <PageBuilder
      pageAssetsData={resolvedPageData}
      noIndex={shouldNoIndexCmsPage(pageId)}
      inProgress={inProgress}
      schemaType={props.schemaType || 'Article'}
      currentPage={props.currentPage}
      featuredListings={getFeaturedListingsProps(pageId, props)}
      options={withRacingThemeSectionComponents()}
      department={department}
      mainClassName={css.cmsPage}
    />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const featuredListingData = state.featuredListings || {};

  const getListingEntitiesById = listingIds => getListingsById(state, listingIds);

  return { pageAssetsData, featuredListingData, getListingEntitiesById, inProgress, error };
};

const mapDispatchToProps = dispatch => ({
  onFetchFeaturedListings: (sectionId, parentPage, listingImageConfig, allSections) =>
    dispatch(fetchFeaturedListings({ sectionId, parentPage, listingImageConfig, allSections })),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CMSPageComponent);

export default CMSPage;
